import { PropsWithChildren } from 'react';
import { LeftPanel } from '../ui-shell/left-panel/left-panel';
import { LeftPanelItems } from '../ui-shell/left-panel/left-panel-items';
//import { LeftPanelMenu } from '../ui-shell/left-panel/left-panel-menu';
//import { LeftPanelMenuItem } from '../ui-shell/left-panel/left-panel-menu-item';
import { LeftPanelFooter } from '../ui-shell/left-panel/left-panel-footer';
import DescriptionIcon from '@material-ui/icons/Description';
import {
  Link,
} from '@backstage/core-components';
// import {
//   identityApiRef,
//   useApi,
//   useRouteRef,
// } from '@backstage/core-plugin-api';
// import useAsync from 'react-use/esm/useAsync';
// import {
//   catalogApiRef,
//   entityRouteRef,
//   entityPresentationApiRef,
// } from '@backstage/plugin-catalog-react';
// import { getCompoundEntityRef } from '@backstage/catalog-model';
import { LeftPanelDivider } from '../ui-shell/left-panel/left-panel-divider';
//import GroupIcon from './GroupIcon';
import SearchIcon from './SearchIcon';
import CatalogIcon from './CatalogIcon';
//import ApiIcon from './ApiIcon';
import SettingsIcon from './SettingsIcon';
//import { useLocation } from 'react-router-dom';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import BuildIcon from '@mui/icons-material/Build';
import SmartToyIcon from '@mui/icons-material/SmartToy';

// const MyGroups = (props: {
//   singularTitle: string;
//   pluralTitle: string;
//   filter?: Record<string, string | symbol | (string | symbol)[]>;
// }) => {
//   const { singularTitle, pluralTitle, filter } = props;

//   const identityApi = useApi(identityApiRef);
//   const catalogApi = useApi(catalogApiRef);
//   const catalogEntityRoute = useRouteRef(entityRouteRef);
//   const entityPresentationApi = useApi(entityPresentationApiRef);

//   const { value: groups } = useAsync(async () => {
//     const profile = await identityApi.getBackstageIdentity();

//     const response = await catalogApi.getEntities({
//       filter: [
//         {
//           kind: 'group',
//           'relations.hasMember': profile.userEntityRef,
//           ...(filter ?? {}),
//         },
//       ],
//       fields: ['metadata', 'kind', 'spec.profile'],
//     });
//     return response.items;
//   }, []);

//   if (!groups?.length) {
//     return null;
//   }

//   // Only member of one group
//   if (groups.length === 1) {
//     const group = groups[0];
//     return (
//       <Link to={catalogEntityRoute(getCompoundEntityRef(group))}>
//         <cds-left-panel-link>
//           <span slot="title-icon"><GroupIcon /></span>{singularTitle}
//         </cds-left-panel-link>
//       </Link>
//     );
//   }

//   // Member of more than one group
//   return (
//     <>
//       <LeftPanelMenu title={pluralTitle}>
//         {groups?.map(group => {
//           const entityDisplayName = entityPresentationApi.forEntity(group);
//           return (
//             <Link to={catalogEntityRoute(getCompoundEntityRef(group))}>
//               <LeftPanelMenuItem title={entityDisplayName.snapshot.primaryTitle}></LeftPanelMenuItem>
//             </Link>
//           );
//         })}
//       </LeftPanelMenu>
//     </>
//   );
// };


export const Root = ({ children }: PropsWithChildren<{}>) => (
//export const Root = ({ children }: PropsWithChildren<{}>) => {  
    // const location = useLocation();
    // const path = location.pathname;

    // const isActive = (route: string) => path.startsWith(route);
    //   return (
  <div style={{ margin: '0', padding: '0', blockSize: '100vh', inlineSize: '100%', display: 'flex' }}>
    <LeftPanel
      collapseMode="responsive"
      expanded={true}
      isNotPersistent={false}
      isNotChildOfHeader={false}
      hideOverlay={true}
    >
      <LeftPanelItems>
        <Link to="/search">
          <cds-left-panel-link>
            <span slot="title-icon"><SearchIcon /></span>Search
          </cds-left-panel-link>
        </Link>
        <LeftPanelDivider />

        <Link to="/documentation">
          <cds-left-panel-link>
            <span slot="title-icon"><DescriptionIcon /></span>
            API Documentation
          </cds-left-panel-link>
        </Link>        
        {/* <Link to="/docs/default/component/api-overview">
          <cds-left-panel-link>
            <span slot="title-icon"><DescriptionIcon /></span>API Documentation
          </cds-left-panel-link>
        </Link>             */}
        <Link to="catalog">
          <cds-left-panel-link>
            <span slot="title-icon"><CatalogIcon /></span>
            API Catalog
          </cds-left-panel-link>
        </Link>
        <Link to="/api-keys">
          <cds-left-panel-link>
            <span slot="title-icon"><VpnKeyIcon /></span>
            API Keys
          </cds-left-panel-link>
        </Link>
        <Link to="/api-agent">
          <cds-left-panel-link>
            <span slot="title-icon"><SmartToyIcon /></span>
            API Agent
          </cds-left-panel-link>
        </Link>
        <Link to="/tools">
          <cds-left-panel-link>
            <span slot="title-icon"><BuildIcon /></span>
            Tools
          </cds-left-panel-link>
        </Link>

        {/* <MyGroups
          singularTitle="My Group"
          pluralTitle="My Groups"
        /> */}
        {/* <Link to="api-docs">
          <cds-left-panel-link>
            <span slot="title-icon"><ApiIcon /></span>APIs
          </cds-left-panel-link>
        </Link> */}
        {/* <Link to="/docs/default/component/api-overview">
          <cds-left-panel-link>
            <span slot="title-icon"><DescriptionIcon /></span>API Overview
          </cds-left-panel-link>
        </Link>         */}
      </LeftPanelItems>      
      {/* <LeftPanelFooter>
        <span slot="actions">
          <Link to="/settings">
            <cds-left-panel-link>
              <span slot="title-icon"><SettingsIcon /></span>Settings
            </cds-left-panel-link>
          </Link>
        </span>
      </LeftPanelFooter> */}
    </LeftPanel>
    <div style={{display: 'flex', flexDirection: 'column', width: '100%', overflow: 'hidden'}}>
      <cds-header>
        <cds-header-left>
          <span className="cds--page-name">Developer Portal</span>
        </cds-header-left>
      </cds-header>
      {children}
    </div>
  </div>
);
//};